export default __webpack_public_path__ + "static/media/Group 1542.1af95517.png";